import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { TransformationSteps } from './components/TransformationSteps';
import { Procedures } from './components/Procedures';
import { MedSpa } from './components/MedSpa';
import { WhyChooseUs } from './components/WhyChooseUs';
import { ConsultationCTA } from './components/ConsultationCTA';
import { Footer } from './components/Footer';
import { LeadConnectorWidget } from './components/LeadConnectorWidget';
export function App() {
  return <div className="min-h-screen w-full bg-white font-sans" data-id="element-0" data-mp="2mn5aeg1k6jg6">
      <Header data-id="element-1" data-mp="31agput0v2nlk" />
      <main data-id="element-2" data-mp="31ayqs2ygxpzt">
        <Hero data-id="element-3" data-mp="31bib1qblcqh0" />
        <TransformationSteps data-id="element-4" data-mp="31c9u61o04vqe" />
        <Procedures data-id="element-5" data-mp="31cjk5p91r2w3" />
        <MedSpa data-id="element-6" data-mp="2wjgrdjc3fxgy" />
        <WhyChooseUs data-id="element-7" data-mp="2wiyy8vkq9zd9" />
        <ConsultationCTA data-id="element-8" data-mp="2wifgpfyzpczr" />
      </main>
      <Footer data-id="element-9" data-mp="28ufnm9e7hai0" />
      <LeadConnectorWidget data-id="element-10" data-mp="28tw5osok2m3z" />
    </div>;
}